import { render, staticRenderFns } from "./sent-message-detail-modal.vue?vue&type=template&id=3bd8a286&"
import script from "./sent-message-detail-modal.vue?vue&type=script&lang=js&"
export * from "./sent-message-detail-modal.vue?vue&type=script&lang=js&"
import style0 from "./sent-message-detail-modal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "sent-message-detail-modal.vue"
export default component.exports